import apiClient from './apiService';
import {parseFiltersToQueryString} from "../utils/parseFiltersToQueryString";

class ZipCodeRangeService {
    constructor() {
        if (ZipCodeRangeService.instance) {
            return ZipCodeRangeService.instance;
        }
        ZipCodeRangeService.instance = this;
    }

    async getAll(filters = {}) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            const response = await apiClient.get(`/zip-code-ranges?${queryString}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching people:", error);
            throw error;
        }
    }

    static getInstance() {
        if (!ZipCodeRangeService.instance) {
            ZipCodeRangeService.instance = new ZipCodeRangeService();
        }
        return ZipCodeRangeService.instance;
    }
}

export default ZipCodeRangeService.getInstance();
